export const normalizeEntityBeforeSaving = (coupon) => {
  const entity = JSON.parse(JSON.stringify(coupon));
  if(entity.supplier){
    entity.supplierName = entity.supplier.name;
  }

  if(entity.group){
    entity.groupName = entity.group.name;
  }

  if(entity.brand){
    entity.brandName = entity.brand.name;
  }

  if(entity.product){
    entity.productName = entity.product.name;
  }

  return entity;
};
